import React, { useEffect, useState, useRef } from "react";
import { GeneralInfo } from "./tab1Content/GeneralInfo";
import { BriefCompanyDetails } from "./tab2Content";
import { Modal, LockCard, GetTheCompany } from "../../../common";
import { Documents } from "./tab3Content/Documents";
import { useSelector } from "react-redux";
import { formatDateToISO } from "../../../../utils/Helper";
import { ReactComponent as ArrowLeft } from "../../../../assets/icons/arrowleft.svg";

import {
  useCreateCompanyFollowMutation,
  useCreatePurchaseDetailsMutation, useCreateWorldBoxOrderMutation,
  useGetCompanyFinanceChartDataMutation,
  useGetCurrentUserQuery,
  useGetPurchaseDetailsQuery,
} from "../../../../store/Company/companyApiSlice";
import { useNavigate, useParams } from "react-router-dom";
import { useLocation, useSearchParams } from "react-router-dom";
import Login from "../../../../pages/public/Login";
import { CreditNotice } from "../../../common/CreditNotice";
import { PurchaseSuccess } from "../../../common/PurchaseSuccess";
import FinancialCharts from "../../../common/FinancialCharts";
import useScreenSize from "../../../../Hooks/useScreenSize";
import { CommonToast } from "../../../common/Toast";
import { format, addMonths, isAfter, isEqual } from 'date-fns';

export const Tabs = ({ company, trevexId, purchaseSubScriptionValid, role, getDetailsClicked, setGetDetailsClicked, selectedEnterprise, setSelectedEnterprise, userEnterprise,
  secondayListedHandler,
  formData,
  setFormData,
  individualData,
  refetch,
  creditNoticePopup,
  setCreditNoticePopup,
  setIsContinue,
  isContinue,
  SubscriptionActive,
  handleGetCompanyPopup,
  isGetTheCompanyOpen
}) => {  
  //Note: Component Refactor needed to optimize the performance of this page.
  const [activeTab, setActiveTab] = useState(1);
  const { isMobile, isTablet, isDesktop } = useScreenSize();
  const [isOpen, setIsOpen] = useState(false);
  const companyId = useParams();
  const [verifiedCompany, setVerifiedCompany] = useState(false);
  const [isCliamedByUser, setIsCliamedByUser] = useState(false);
  const [claimed, setClaimed] = useState(false);
  const [creditType, setCreditType] = useState("credit")
  // const [creditNoticePopup, setCreditNoticePopup] = useState(false);
  const [isFollowed, setIsFollowed] = useState(false);
  const [companyExists, setCompanyExists] = useState(false);
  const [purchasedCompanyPopup, setPurchasedCompanyPopup] = useState(false);
  const { userInfo, isLoggedIn, token } = useSelector((state) => state.auth);
  const [showUploadInput, setShowUploadInput] = useState(false);
  const [subscriptionActive, setSubscriptionActive] = useState();
  const todayDate = formatDateToISO(new Date());
  const currentDate = new Date(todayDate);
  const { data: getPurchaseDetails } = useGetPurchaseDetailsQuery({
    companyID: company?.companyID || company?.company?.win,
    userID: userInfo?.individual[0]?.userID,
    token: token
  });
  const [data, setData] = useState();
  useEffect(() => {
    if (typeof (individualData?.individualID) === "number") {
      setData(individualData);
    }
  }, [individualData])

  useEffect(() => {
    setSubscriptionActive(SubscriptionActive)
  }, [SubscriptionActive])
  const [createOrderWorldBox, { isLoading: orderCreating }] =
    useCreateWorldBoxOrderMutation();
  const [createPurchaseDetails] = useCreatePurchaseDetailsMutation();
  const [createFollow, { isLoading }] = useCreateCompanyFollowMutation();
  const [resData, setResData] = useState([]);
  const containerRef = useRef(null);
  const [isLeftButtonDisabled, setIsLeftButtonDisabled] = useState(true);
  const [isRightButtonDisabled, setIsRightButtonDisabled] = useState(false);

  useEffect(() => {
    if (company && getPurchaseDetails) {
      const companyID = company?.companyID || company?.company?.win;
      const purchaseID = getPurchaseDetails?.purchase?.companyID || (getPurchaseDetails?.enterprise?.status === "ORDERED" ? getPurchaseDetails?.enterprise?.companyID : null);
      
      setCompanyExists(companyID === purchaseID);
    } else {
      setCompanyExists(false);
    }
    
  }, [company, getPurchaseDetails]);

  const currentURL = window.location.href;
  const parts = currentURL?.split("/");
  const currentCompanyId = parts[parts.length - 1];
  const navigate = useNavigate();
  const { id } = useParams();

  // const handleGetClicked = () => {
  // setGetDetailsClicked(!getDetailsClicked)
  // }
  const handleGetCompany = async () => {
    localStorage.removeItem("UpgradePlan");

    const jsonData = JSON.stringify(currentCompanyId);
    localStorage.setItem("payasyougoCompanyID", jsonData);
    let status =
      company?.companyID === undefined
        ? "listing"
        : company?.verifiedCompany != null
          ? "verified"
          : (company?.claimed && "claimed") || (company?.draft && "warning");
    localStorage.setItem("paycompanyStatus", status);

    if (subscriptionActive?.no_of_profile_views >= 1 || userEnterprise?.length > 0) {
      setCreditNoticePopup(true);
    } else if (!verifiedCompany && token) {
      window.scrollTo(0, 0);
      return navigate("/plans", {
        state: { company_id: id },
      });
    } else if (!verifiedCompany && !token) {
      window.scrollTo(0, 0);
      // alert("came to /login?guest=true")
      // return navigate("/login?guest=true", {
      // next: "/plans",
      // state: { company_id: id },
      // });
      return navigate("/plans", {
        state: { company_id: id },
      });
    }
    else {
      window.scrollTo(0, 0);
      localStorage.removeItem("UpgradePlan");
      const jsonData = JSON.stringify(currentCompanyId);
      localStorage.setItem("payasyougoCompanyID", jsonData);
      navigate("/plans");
    }
  };

  let subscriptionID
  let subscriptionEndDate
  let subscriptionStartDate
  let isSubscriptionValid
  let companyViewed
  let companyIDs

  useEffect(() => {
    if (userInfo?.individual?.length > 0 && userInfo?.individual[0]?.individualSubscription?.length > 0) {
      subscriptionID =
        userInfo?.individual[0]?.individualSubscription[0]?.subscriptionID;
      subscriptionEndDate =
        userInfo?.individual[0]?.individualSubscription[0]?.date_of_end;
      subscriptionStartDate =
        userInfo?.individual[0]?.individualSubscription[0]?.date_of_start;
      isSubscriptionValid =
        new Date(subscriptionEndDate) >= new Date(todayDate);

      companyViewed =
        userInfo?.individual[0]?.individualSubscription[0]?.CompanyViewed;
      companyIDs = companyViewed?.map(
        (view) => view?.company_viewed_detailsID?.companyID
      );
    }
  }, [userInfo])

  const isCompanyIDPresent = companyIDs?.includes(currentCompanyId);

  const [isLoginOpen, setLoginOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const isClaimed = data?.individual[0]?.requestIndividual?.find(
      (i) => i?.companyID?.companyID === company?.companyID
    );
    if (isClaimed?.companyID?.claimed === true) {
      setIsCliamedByUser(true);
    }
  }, [company, data?.individual]);

  function isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
  }
  const paynowRedirect = () => {
    window.scrollTo(0, 0);
    navigate("/plans", { state: id });
  }
  useEffect(() => {
    setLoginOpen(searchParams.get("login") === "true");
  }, []);

  useEffect(() => {
    if (
      company &&
      company?.verifiedCompany !== null &&
      company?.verifiedCompany !== undefined
    ) {
      let isVerified = isObjectEmpty(company?.verifiedCompany);
      setVerifiedCompany(!isVerified);
    }
  }, [company]);

  const handleModalToggle = () => {
    setIsOpen(!isOpen);
    setActiveTab(1);
  };

  useEffect(() => {
    if (getDetailsClicked) {
      handleModalToggle();
    }
  }, [getDetailsClicked])

  const handleRefresh = () => {
    window?.location?.reload();
  };

  const handleTabClick = (tabNumber) => {
    setActiveTab(tabNumber);
    refetch();
    localStorage.removeItem("UpgradePlan");
    const jsonData = JSON.stringify(currentCompanyId);
    localStorage.setItem("payasyougoCompanyID", jsonData);
    if (!isLoggedIn) {
      setIsOpen(true);
    }
  };
  const handleLoginModalCLose = () => {
    setLoginOpen(false);
  };

  // const handlePurchased = async (type = 'credit') => {
  // const profileStartDate = formatDateToISO(currentDate);
  // let customerreference;
  // if (!formData.name.trim()) {
  // customerreference = 'No reference data provided';
  // } else {
  // customerreference = `Name: ${formData.name},
  // Designation: ${formData.designation},
  // Email: ${formData.email},
  // Contact: ${formData.contactNumber || 'N/A'},`;
  // }
  // const purchasedata = {
  // planID: subscriptionID,
  // purchaseDate: subscriptionStartDate,
  // expireDate: subscriptionEndDate,
  // userID: userInfo?.individual[0]?.userID,
  // companyID: currentCompanyId,
  // purchaseType: "Subscription",
  // ...(type === 'enterprise' && { enterpriseID: selectedEnterprise?.id })
  // };
  // const res = await createPurchaseDetails({
  // data: purchasedata,
  // });
  // if (res?.data?.data?.message) {
  // let status =
  // company?.companyID === undefined
  // ? "listing"
  // : company?.verifiedCompany != null
  // ? "verified"
  // : (company?.claimed && "claimed") || (company?.draft && "warning");
  // if (status != "listing" && status != "warning") {
  // if (!isFollowed) {
  // if (trevexId) {
  // const res = await createFollow({
  // data: {
  // companyID: company?.companyID,
  // userID: userInfo?.individual[0]?.userID,
  // },
  // token,
  // }).unwrap();
  // }
  // }
  // }
  // let postData = {};
  // let win_no;
  // if (status === "listing") {
  // win_no = company?.company.win;
  // postData = {
  // win_number: win_no,
  // companyID: id,
  // userID: userInfo?.individual[0]?.userID,
  // customerreference: customerreference,
  // };
  // } else if (status === "warning") {
  // win_no = company?.wb_win;
  // if (win_no == null) {
  // if (company?.companyAddress?.length <= 0) {
  // postData = {
  // companyID: id,
  // companyname: company?.registered_company_name,
  // address1: company?.country_code,
  // city: company?.country_code,
  // countrycode: company?.country_code,
  // currency: "USD",
  // userID: userInfo?.individual[0]?.userID,
  // customerreference: customerreference,
  // };
  // } else {
  // postData = {
  // companyID: id,
  // companyname: company?.registered_company_name,
  // address1:
  // company?.companyAddress[0]?.company_address_detailsID
  // ?.address_line_1 +
  // " " +
  // company?.companyAddress[0]?.company_address_detailsID
  // ?.address_line_2 +
  // " " +
  // company?.companyAddress[0]?.company_address_detailsID?.area +
  // " " +
  // company?.companyAddress[0]?.company_address_detailsID?.city +
  // " " +
  // company?.companyAddress[0]?.company_address_detailsID?.state,
  // city: company?.companyAddress[0]?.company_address_detailsID?.state,
  // countrycode:
  // company?.companyAddress[0]?.company_address_detailsID?.country,
  // currency: "USD",
  // userID: userInfo?.individual[0]?.userID,
  // };
  // }
  // } else {
  // postData = {
  // win_number: win_no,
  // companyID: id,
  // userID: userInfo?.individual[0]?.userID,
  // };
  // }
  // }
  // if (type === 'credit' && (status === "listing" || status === "warning")) {
  // //NOTE: this function is not being used same API was getting called from Banner company card so that is being used
  // //DONE: add Purchase in the createOrderWorldBox API request, 
  // // This PUrchase ID you will get from createPurchaseDetails res this is called on line 161
  // // Related changes are in backend in views.py > WordboxOrderCreateView line 1688 
  // try {
  // const data = await createOrderWorldBox({
  // data: postData,
  // token,
  // }).unwrap();
  // if (data) {
  // }
  // } catch (error) {
  // }
  // }

  // localStorage?.removeItem("payasyougoCompanyID");
  // setCreditNoticePopup(false);
  // setPurchasedCompanyPopup(true);
  // } else if (res.error) {
  // CommonToast?.error(res.error.data.error ?? 'Purchase failure')
  // }
  // };

  const handlePurchased = async (type = 'credit') => {
    subscriptionID =
      userInfo?.individual[0]?.individualSubscription[0]?.subscriptionID;
    subscriptionEndDate =
      userInfo?.individual[0]?.individualSubscription[0]?.date_of_end;
    subscriptionStartDate =
      userInfo?.individual[0]?.individualSubscription[0]?.date_of_start;
    isSubscriptionValid =
      new Date(subscriptionEndDate) >= new Date(todayDate);

    companyViewed =
      userInfo?.individual[0]?.individualSubscription[0]?.CompanyViewed;
    companyIDs = companyViewed?.map(
      (view) => view?.company_viewed_detailsID?.companyID
    );

    setCreditType(type);
    const profileStartDate = formatDateToISO(currentDate);
    let customerreference;
    if (!formData.name.trim()) {
      customerreference = 'No reference data provided';
    } else {
      customerreference = `Name: ${formData.name},
      Designation: ${formData.designation},
      Email: ${formData.email},
      Contact: ${formData.contactNumber || 'N/A'},`;
    }

    const purchasedata = {
      planID: subscriptionID,
      purchaseDate: format(new Date(), 'yyyy-MM-dd'), // yyyy-mm-dd
      expireDate: format(addMonths(new Date(), 1), 'yyyy-MM-dd'),     // yyyy-mm-dd
      userID: userInfo?.individual[0]?.userID,
      companyID: currentCompanyId,
      purchaseType: "Subscription",
      ...(type === 'enterprise' && { enterpriseID: selectedEnterprise?.id, customerreference: customerreference, })
    };

    const res = await createPurchaseDetails({
      data: purchasedata,
      token
    });
    if (res.data) {
      let status =
        company?.companyID === undefined
          ? "listing"
          : company?.verifiedCompany != null
            ? "verified"
            : (company?.claimed && "claimed") || (company?.draft && "warning");
      if (status != "listing" && status != "warning") {
        if (!isFollowed) {
          if (trevexId) {
            const response = await createFollow({
              data: {
                companyID: company?.companyID,
                userID: userInfo?.individual[0]?.userID,
              },
              token,
            }).unwrap();
          }
        }
      }
      let postData = {};
      let win_no;
      if (status === "listing") {
        win_no = company?.company.win;
        postData = {
          win_number: win_no,
          companyID: id,
          userID: userInfo?.individual[0]?.userID,
          customerreference: customerreference,
        };
      } else if (status === "warning") {
        win_no = company?.wb_win;
        if (win_no == null) {
          if (company?.companyAddress?.length <= 0) {
            postData = {
              companyID: id,
              companyname: company?.registered_company_name,
              address1: company?.country_code,
              city: company?.country_code,
              countrycode: company?.country_code,
              currency: "USD",
              userID: userInfo?.individual[0]?.userID,
              customerreference: customerreference,
            };
          } else {
            postData = {
              companyID: id,
              companyname: company?.registered_company_name,
              address1:
                company?.companyAddress[0]?.company_address_detailsID
                  ?.address_line_1 +
                " " +
                company?.companyAddress[0]?.company_address_detailsID
                  ?.address_line_2 +
                " " +
                company?.companyAddress[0]?.company_address_detailsID?.area +
                " " +
                company?.companyAddress[0]?.company_address_detailsID?.city +
                " " +
                company?.companyAddress[0]?.company_address_detailsID?.state,
              city: company?.companyAddress[0]?.company_address_detailsID?.state,
              countrycode:
                company?.companyAddress[0]?.company_address_detailsID?.country,
              currency: "USD",
              userID: userInfo?.individual[0]?.userID,
              customerreference: customerreference,
            };
          }
        } else {
          postData = {
            win_number: win_no,
            companyID: id,
            userID: userInfo?.individual[0]?.userID,
            customerreference: customerreference,
          };
        }
      }
      if (type === 'credit' && (status === "listing" || status === "warning")) {
        //DONE: add Purchase in the createOrderWorldBox API request, 
        // This PUrchase ID you will get from createPurchaseDetails res this is called on line 473
        // Related changes are in backend in views.py > WordboxOrderCreateView line 1688
        try {
          const data = await createOrderWorldBox({
            data: res?.data?.purchaseID ? { ...postData, purchaseID: res?.data?.purchaseID } : postData,
            token,
          }).unwrap();
          if (data) {
          }
        } catch (error) {
        }
      }

      localStorage?.removeItem("payasyougoCompanyID");
      setCreditNoticePopup(false);
      setPurchasedCompanyPopup(true);
    } else if (res.error) {
      CommonToast?.error(res.error.data.error ?? 'Purchase failure')
    }
  };
  const createWorldBoxOrder = async () => {
    localStorage.removeItem("UpgradePlan");
    let customerreference;
    if (!formData.name.trim()) {
      customerreference = 'No reference data provided';
    } else {
      customerreference = `Name: ${formData.name},
Designation: ${formData.designation},
Email: ${formData.email},
Contact: ${formData.contactNumber || 'N/A'},`;
    }
    let status =
      company?.companyID === undefined
        ? "listing"
        : company?.verifiedCompany != null
          ? "verified"
          : (company?.claimed && "claimed") || (company?.draft && "warning");
    let postData = {};
    let win_no;
    if (status === "listing") {
      win_no = company?.company.win;
      postData = {
        win_number: win_no,
        companyID: id,
        userID: userInfo?.individual[0]?.userID,
        customerreference: customerreference
      };
    } else if (status === "warning") {
      win_no = company?.wb_win;
      if (win_no == null) {
        if (company?.companyAddress?.length <= 0) {
          postData = {
            companyID: id,
            companyname: company?.registered_company_name,
            address1: company?.country_code,
            city: company?.country_code,
            countrycode: company?.country_code,
            currency: "USD",
            userID: userInfo?.individual[0]?.userID,
            customerreference: customerreference
          };
        } else {
          postData = {
            companyID: id,
            companyname: company?.registered_company_name,
            address1:
              company?.companyAddress[0]?.company_address_detailsID
                ?.address_line_1 +
              " " +
              company?.companyAddress[0]?.company_address_detailsID
                ?.address_line_2 +
              " " +
              company?.companyAddress[0]?.company_address_detailsID?.area +
              " " +
              company?.companyAddress[0]?.company_address_detailsID?.city +
              " " +
              company?.companyAddress[0]?.company_address_detailsID?.state,
            city: company?.companyAddress[0]?.company_address_detailsID?.state,
            countrycode:
              company?.companyAddress[0]?.company_address_detailsID?.country,
            currency: "USD",
            userID: userInfo?.individual[0]?.userID,
            customerreference: customerreference,
          };
        }
      } else {
        postData = {
          win_number: win_no,
          companyID: id,
          userID: userInfo?.individual[0]?.userID,
          customerreference: customerreference
        };
      }
    }

    if (status === "listing" || status === "warning") {
      setIsContinue(true)
      localStorage.setItem("createWorldbox", true);
      localStorage.setItem("worldboxData", JSON.stringify(postData));
      localStorage.removeItem("UpgradePlan");
      const jsonData = JSON.stringify(currentCompanyId);
      localStorage.setItem("payasyougoCompanyID", jsonData);
      handleGetCompanyPopup();
    } else {
      setIsContinue(true)
      localStorage.removeItem("UpgradePlan");
      const jsonData = JSON.stringify(currentCompanyId);
      localStorage.setItem("payasyougoCompanyID", jsonData);
      handleGetCompanyPopup();
      if (token) {
        window.scrollTo(0, 0);
        return navigate("/plans", {
          state: { company_id: id },
        });
      } else if (!token) {
        window.scrollTo(0, 0);
        // return navigate("/login?guest=true", {
        // next: "/plans",
        // state: { company_id: id },
        // });
        return navigate("/plans", {
          state: { company_id: id },
        });
      }
    }
  };

  // const handleGetCompany = async () => {
  // localStorage.removeItem("UpgradePlan");

  // const jsonData = JSON.stringify(currentCompanyId);
  // localStorage.setItem("payasyougoCompanyID", jsonData);
  // let status =
  // company?.companyID === undefined
  // ? "listing"
  // : company?.verifiedCompany != null
  // ? "verified"
  // : (company?.claimed && "claimed") || (company?.draft && "warning");
  // localStorage.setItem("paycompanyStatus", status);

  // if (subscriptionActive?.no_of_profile_views >= 1 || userEnterprise?.length > 0) {
  // setCreditNoticePopup(true);
  // } else if (!verifiedCompany && token) {
  // window.scrollTo(0, 0);
  // return navigate("/plans", {
  // state: { company_id: id },
  // });
  // } else if (!verifiedCompany && !token) {
  // window.scrollTo(0, 0);
  // // return navigate("/login?guest=true", {
  // // next: "/plans",
  // // state: { company_id: id },
  // // });
  // return navigate("/plans", {
  // state: { company_id: id },
  // });
  // }
  // else {
  // window.scrollTo(0, 0);
  // localStorage.removeItem("UpgradePlan");
  // const jsonData = JSON.stringify(currentCompanyId);
  // localStorage.setItem("payasyougoCompanyID", jsonData);
  // navigate("/plans");
  // }
  // };
  const [clicked, setClicked] = useState(false)
  useEffect(() => {
    // Check if container has overflow
    const container = containerRef.current;
    setIsLeftButtonDisabled((container?.scrollLeft === 0 || container?.scrollLeft < 150));
    setIsRightButtonDisabled(container?.scrollLeft + container?.clientWidth >= container?.scrollWidth);
  }, [clicked]);
  const handleScrollLeft = () => {
    const container = containerRef.current;
    if (container?.scrollLeft !== 0) {
      container?.scrollTo({
        left: container?.scrollLeft - 150,
        behavior: 'smooth'
      });
    };
    setClicked(!clicked)
  };

  const handleScrollRight = () => {
    const container = containerRef.current;
    container?.scrollTo({
      left: container?.scrollLeft + 150,
      behavior: 'smooth'
    });
    setTimeout(() => {
      setClicked(!clicked)
    }, [0])
  };

  const isSecondary = (!company?.companyID?.startsWith("TRX") || company?.verifiedCompany || company?.claimed)
  const isSecondaryOrListed = !company?.verifiedCompany && !company?.claimed
  return (
    <>
      {isLoginOpen && (
        <Modal modalHandle={handleLoginModalCLose}>
          <Login />
        </Modal>
      )}
      <div className="relative my-3 sm:my-6">
        {/* <button className={`absolute top-[13px] left-[-10px] p-1 rounded-full sm:hidden`} onClick={handleScrollLeft}><ArrowLeft className="w-[16px] h-[16px]" /></button> */}
        {
          // company?.worldbox_order == 0 ?
            <div ref={containerRef} className={`flex justify-between border mx-1 sm:mx-0 ${!isSecondary ? "sm:grid sm:grid-cols-3" : "sm:grid sm:grid-cols-4"} gap-0 sm:gap-2 bg-[#00294026] sm:bg-white rounded-[5px] sm:rounded-2xl text-f12 sm:text-f16 px-2 sm:px-3 py-2 overflow-x-scroll no-scrollbar sm:shadow-none`}>
              <div
                className={`flex items-center justify-center sm:py-2 text-[12px] sm:text-[12px] h-[22px] sm:h-auto min-w-[60px] sm:px-1 sm:min-w-[150px] sm:px-4 cursor-pointer ${activeTab === 1
                  ? "bg-[#002940] text-white sm:bg-transparent sm:text-primary font-semibold shadow-md rounded px-1"
                  : "bg-transparent text-gray-800"
                  }`}
                onClick={() => handleTabClick(1)}
              >
                {isMobile ? "General Info" : "General Information"}
              </div>
              <div
                // className={`py-2 min-w-[150px] px-1 sm:px-4 cursor-pointer ${activeTab === 2 && isLoggedIn || (activeTab === 2 && isLoggedIn && role === "ED") || (activeTab === 2 && isLoggedIn && role === "AD") || (activeTab === 2 && isLoggedIn && role === "CL")
                //   ? "bg-transparent text-primary font-semibold shadow-md rounded"
                //   : "bg-transparent text-gray-800"
                //   }`}
                className={`flex items-center justify-center text-[12px] sm:text-[12px] sm:py-2 h-[22px] sm:h-auto min-w-[80px] sm:px-1 sm:min-w-[150px] sm:px-4 cursor-pointer ${activeTab === 2 && isLoggedIn || (activeTab === 2 && isLoggedIn && role === "ED") || (activeTab === 2 && isLoggedIn && role === "AD") || (activeTab === 2 && isLoggedIn && role === "CL")
                  ? "bg-[#002940] text-white sm:bg-transparent sm:text-primary font-semibold shadow-md rounded px-1"
                  : "bg-transparent text-gray-800"
                  }`}
                onClick={() => handleTabClick(2)}
              >
                Business Details
              </div>
              <div
                // className={`py-2 min-w-[150px] px-1 sm:px-4 cursor-pointer ${activeTab === 4 && isLoggedIn || (activeTab === 4 && isLoggedIn && role === "ED") || (activeTab === 4 && isLoggedIn && role === "AD") || (activeTab === 4 && isLoggedIn && role === "CL")
                //   ? "bg-transparent text-primary font-semibold shadow-md rounded"
                //   : "bg-transparent text-gray-800"
                //   }`}
                className={`flex items-center justify-center sm:py-2 text-[12px] sm:text-[12px] h-[22px] sm:h-auto min-w-[60px] sm:px-1 sm:min-w-[150px] sm:px-4 cursor-pointer ${activeTab === 4 && isLoggedIn || (activeTab === 4 && isLoggedIn && role === "ED") || (activeTab === 4 && isLoggedIn && role === "AD") || (activeTab === 4 && isLoggedIn && role === "CL")
                  ? "bg-[#002940] text-white sm:bg-transparent sm:text-primary font-semibold shadow-md rounded px-1"
                  : "bg-transparent text-gray-800"
                  }`}
                onClick={() => handleTabClick(4)}
              >
                Financials
              </div>
              {isSecondary ?
                <div
                  // className={`py-2 min-w-[150px] px-1 sm:px-4 cursor-pointer ${activeTab === 3 && isLoggedIn || (activeTab === 3 && isLoggedIn && role === "ED") || (activeTab === 3 && isLoggedIn && role === "AD") || (activeTab === 3 && isLoggedIn && role === "CL")
                  //   ? "bg-transparent text-primary font-semibold shadow-md rounded"
                  //   : "bg-transparent text-gray-800"
                  //   }`}
                  className={`flex items-center justify-center sm:py-2 text-[12px] sm:text-[12px] h-[22px] sm:h-auto min-w-[60px] sm:px-1 sm:min-w-[150px] sm:px-4 cursor-pointer ${activeTab === 3 && isLoggedIn || (activeTab === 3 && isLoggedIn && role === "ED") || (activeTab === 3 && isLoggedIn && role === "AD") || (activeTab === 3 && isLoggedIn && role === "CL")
                    ? "bg-[#002940] text-white sm:bg-transparent sm:text-primary font-semibold shadow-md rounded px-1"
                    : "bg-transparent text-gray-800"
                    }`}
                  onClick={() => handleTabClick(3)}
                >
                  Documents
                </div> : null}
            </div> 
            // :
            // <div className="grid grid-cols-2 gap-2 bg-white rounded-2xl text-f12 sm:text-f16 px-3 py-2">
            //   <div
            //     // className={`py-2 min-w-[150px] px-1 sm:px-4 cursor-pointer ${activeTab === 1
            //     //   ? "bg-transparent text-primary font-semibold shadow-md rounded"
            //     //   : "bg-transparent text-gray-800"
            //     //   }`}
            //     className={`flex items-center justify-center sm:py-2 text-[12px] sm:text-[12px] h-[22px] sm:h-auto min-w-[104px] sm:px-1 sm:min-w-[150px] sm:px-4 cursor-pointer ${activeTab === 1
            //       ? "bg-[#002940] text-white sm:bg-transparent sm:text-primary font-semibold shadow-md rounded px-1"
            //       : "bg-transparent text-gray-800"
            //       }`}
            //     onClick={() => handleTabClick(1)}
            //   >
            //     General Information
            //   </div>
            //   <div
            //     // className={`py-2 min-w-[150px] px-1 sm:px-4 cursor-pointer ${activeTab === 2 && isLoggedIn || (activeTab === 2 && isLoggedIn && role === "ED") || (activeTab === 2 && isLoggedIn && role === "AD") || (activeTab === 2 && isLoggedIn && role === "CL")
            //     //   ? "bg-transparent text-primary font-semibold shadow-md rounded"
            //     //   : "bg-transparent text-gray-800"
            //     //   }`}
            //     className={`flex items-center justify-center sm:py-2 text-[12px] sm:text-[12px] h-[22px] sm:h-auto min-w-[104px] sm:px-1 sm:min-w-[150px] sm:px-4 cursor-pointer ${activeTab === 2 && isLoggedIn || (activeTab === 2 && isLoggedIn && role === "ED") || (activeTab === 2 && isLoggedIn && role === "AD") || (activeTab === 2 && isLoggedIn && role === "CL")
            //       ? "bg-[#002940] text-white sm:bg-transparent sm:text-primary font-semibold shadow-md rounded px-1"
            //       : "bg-transparent text-gray-800"
            //       }`}
            //     onClick={() => handleTabClick(2)}
            //   >
            //     Business Details
            //   </div>
            // </div>
            }
        <div className="mt-3 sm:mt-6">
          {activeTab === 1 && (
            <GeneralInfo
              handleGetCompany={handleGetCompany}
              createWorldBoxOrder={createWorldBoxOrder}
              company={company}
              trevexId={trevexId}
              subscriptionActive={subscriptionActive?.no_of_profile_views >= 1 || userEnterprise?.length > 0}
              purchaseSubScriptionValid={purchaseSubScriptionValid}
              handlePurchased={() => {
                setCreditNoticePopup(true)
              }}
            />
          )}

          {activeTab !== 1 && role !== "AD" && role !== "ED" && role !== "CL" &&
            isCliamedByUser === false &&
            (companyExists === false || !purchaseSubScriptionValid) && (
              <Modal modalHandle={handleModalToggle}>
                {
                  <GetTheCompany
                    company={company}
                    company_id={company?.companyID}
                    subscriptionActive={(subscriptionActive?.no_of_profile_views >= 1 || userEnterprise?.length > 0)}
                    handleGetCompany={handleGetCompany}
                    fromBanner
                    createWorldBoxOrder={createWorldBoxOrder}
                    handlePurchased={() => setCreditNoticePopup(true)}
                    acknowledgement={isSecondaryOrListed ? true : false}
                    des={
                      isSecondaryOrListed ? " The request is sourced from secondary sources and will take up to 5 working days." : " Request to get the company information and TREVEX will do that for you."
                    }
                    isContinue={isContinue}
                    setIsContinue={setIsContinue}
                    secondayListedHandler={secondayListedHandler}
                    formData={formData}
                    setFormData={setFormData}
                    button={"Get Details"}
                  />
                }
              </Modal>
            )}

          {/* Pay Now issue, we don't want to show this. Needs to be looked into*/}
          {activeTab !== 1 && isLoggedIn === false && (
            // <Modal modalHandle={handleModalToggle}>
            // {<LockCard paynow={() => company?.claimed
            // ? handleGetCompany()
            // : createWorldBoxOrder()} activeTab={activeTab} isLoggedIn={isLoggedIn} token={token} companyID={company?.companyID || company?.company?.win} />}
            // </Modal>
            null
          )}

          {((activeTab === 2 && isLoggedIn && trevexId && companyExists) ||
            (activeTab === 2 && isLoggedIn && trevexId && isCliamedByUser) || (activeTab === 2 && isLoggedIn && role === "ED") || (activeTab === 2 && isLoggedIn && role === "AD") || (activeTab === 2 && isLoggedIn && role === "CL") || (activeTab === 2 && isLoggedIn && purchaseSubScriptionValid)) && (
              <BriefCompanyDetails company={company} role={role} />
            )}
          {((activeTab === 3 && isLoggedIn && trevexId && companyExists) ||
            (activeTab === 3 && isLoggedIn && trevexId && isCliamedByUser) || (activeTab === 3 && isLoggedIn && role === "ED") || (activeTab === 3 && isLoggedIn && role === "AD") || (activeTab === 3 && isLoggedIn && role === "CL") || (activeTab === 3 && isLoggedIn && purchaseSubScriptionValid)) && (
              <Documents />
            )}
          {((activeTab === 4 && isLoggedIn && trevexId && companyExists) ||
            (activeTab === 4 && isLoggedIn && trevexId && isCliamedByUser) || (activeTab === 4 && isLoggedIn && role === "ED") || (activeTab === 4 && isLoggedIn && role === "AD") || (activeTab === 4 && isLoggedIn && role === "CL") || (activeTab === 4 && isLoggedIn && purchaseSubScriptionValid)) && (
              <FinancialCharts companyId={id} setShowUploadInput={setShowUploadInput} />
            )}
        </div>
        {/* <button className={`absolute top-[13px] right-[-10px] p-1 rounded-full sm:hidden`} onClick={handleScrollRight}><ArrowLeft className="w-[16px] h-[16px] rotate-180" /></button> */}
      </div>
      {purchasedCompanyPopup && (
        <Modal modalHandle={handleRefresh}>
          <PurchaseSuccess
            onclick={handleRefresh}
            title={creditType === "credit" ? "Purchase Company Successful" : `Company Added to ${selectedEnterprise?.name}`}
            des={creditType === "credit" ? "Enjoy the Incredable Experience of the companies" : "The company is now added to the Tracking Companies Listing for this enterprise solution"}
            button={"continue"}
          />
        </Modal>
      )}
      {creditNoticePopup && (
        <Modal modalHandle={() => setCreditNoticePopup(false)}>
          <p className="text-f20 font-semibold text-left">Get this company</p>
          {userEnterprise?.length > 0 && <p className="text-f16 text-gray-500 text-left">select how you want to proceed to buy this company</p>}
          <CreditNotice
            onclick={() => setCreditNoticePopup(false)}
            handlePurchased={handlePurchased}
            company_id={currentCompanyId}
            NoCredits={!subscriptionActive || subscriptionActive?.no_of_profile_views == 0}
            title={
              subscriptionActive?.no_of_profile_views >= 1
                ? "Attention!!"
                : "Oopss..."
            }
            des={
              subscriptionActive?.no_of_profile_views >= 1
                ? userEnterprise?.length > 0 ? `1 credit out of ${subscriptionActive?.no_of_profile_views
                  } credit(s)` : `You are about to use <b> 1 credit </b> for these request. You will be left with <b> ${SubscriptionActive?.no_of_profile_views - 1
                  } more credit of this month </b>`
                : "Get this company with your subscription!"
            }
            des2={`Currently you have <b> ${subscriptionActive?.no_of_profile_views} Credit </b>. Upgrade your plan to get more credit or else continue via payment method`}
            leftButton={
              subscriptionActive?.no_of_profile_views >= 1
                ? "Cancel"
                : "Buy Credits"
            }
            userInfo={userInfo}
            rightButton={"Process"}
            selectedEnterprise={selectedEnterprise}
            setSelectedEnterprise={setSelectedEnterprise}
            userEnterprise={userEnterprise}
          />
        </Modal>
      )}
    </>
  );
};

